export function getOpenSearchJoubunProperties() {
  const properties =
    'width=1280,height=' +
    window.innerHeight +
    ',left=' +
    (window.screenX + window.innerWidth / 2 - 640) +
    ',top=' +
    (window.screenTop + 50) +
    ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,';
  return properties;
}

export function getSearchSmallCategoryObj(categoryTree, smallCategoryId) {
  if (!smallCategoryId) {
    return {};
  }
  let resSmallCategory = {};
  for (let key in categoryTree) {
    categoryTree[key].forEach(bigCategory => {
      bigCategory.smallCategories.forEach(smallCategory => {
        if (String(smallCategory.smallCategoryId) === String(smallCategoryId)) {
          resSmallCategory = smallCategory;
          return;
        }
      });
    });
  }
  return resSmallCategory;
}

// Test Created
export function getItemsToShowFromSearchResults(numberOfItemsToLoad, searchResults, keyNameForTargetList) {
  let output = [];
  let addedItemsCount = 0;
  const copiedSearchResults = JSON.parse(JSON.stringify(searchResults));
  const numberOfItemsInList = copiedSearchResults.flatMap(i => i[keyNameForTargetList].length);

  for (const [index, numberOfItems] of numberOfItemsInList.entries()) {
    if (numberOfItemsToLoad > numberOfItems + addedItemsCount) {
      output.push(copiedSearchResults[index]);
      addedItemsCount = addedItemsCount + numberOfItems;
      continue;
    }

    if (numberOfItemsToLoad === addedItemsCount) {
      break;
    }

    output.push(copiedSearchResults[index]);
    const numberOfItemsToInclude = numberOfItemsToLoad - addedItemsCount;
    output[index][keyNameForTargetList] = copiedSearchResults[index][keyNameForTargetList].slice(0, numberOfItemsToInclude);
    break;
  }

  return output;
}

// Test Created
export function runCallbackWhenScrollDownToBottom({ target: { scrollTop, clientHeight, scrollHeight } }, callback) {
  if (scrollTop + clientHeight >= scrollHeight) {
    callback();
  }
}



// WEBPACK FOOTER //
// ./src/functions/pages/search_joubun/index.js